import script from "./s156-h.vue?vue&type=script&setup=true&lang=js"
export * from "./s156-h.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__